"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  this.limit = _typeof(e) === 'object' ? e.target.value : e;
  this.updateState('perPage', this.limit);
  this.dispatch('limit', parseInt(this.limit));

  if (sendRequest) {
    this.setPage(1);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/set-limit.js
// module id = 938
// module chunks = 0